const QUERY_INFO_CLASS = 'query-info';

export { QUERY_INFO_CLASS };
